import { Sponsor } from "../../data/interfaces";
import firebase from "../../firebase/firebase";
import { Dispatch } from "redux";
import { DB_COLLECTIONS } from "../../firebase/collections";
import { mapSponsor } from "../../utils/mapping";

/**
 * Fetches entire sponsors list.
 * @function
 * @async
 */
export const getSponsors = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch({
      type: "SPONSORS_LIST_LOADING",
    });

    let output: Sponsor[] = [];

    console.log("[Firebase read sponsors] sponsors list");
    const collectionRef = firebase.firestore().collection(DB_COLLECTIONS.SPONSORS);
    let querySnapshot = await collectionRef.orderBy("name").get();

    // Impossible but in case...
    if (!querySnapshot) {
      dispatch({
        type: "SPONSORS_LIST_LOADED",
        payload: {
          sponsors: output,
        },
      });
      return;
    }

    querySnapshot.forEach((doc:any) => {
      output.push(mapSponsor(doc.id, doc.data()));
    });

    console.log(output);

    dispatch({
      type: "SPONSORS_LIST_LOADED",
      payload: {
        sponsors: output,
      },
    });
    return;
  } catch (err) {
    console.error(err);
    dispatch({
      type: "SPONSORS_LIST_ERROR",
    });
  }
};
